import {
  SpecialtyCta as HygraphSpecialtyCtaProps,
  SpecialtyCtaType as HygraphSpecialtyCtaType,
} from '@/lib/types';

import BrowseSpecialtyJobsCTA from '@/components/static/browse-specialty-jobs-cta';
import RegisterCTA from '@/components/static/register-cta';
import SearchSpecialtyJobsByLocationCTA from '@/components/static/search-specialty-jobs-by-location-cta';

const componentByEnumeration = {
  [HygraphSpecialtyCtaType.Register]: RegisterCTA,
  [HygraphSpecialtyCtaType.BrowseSpecialtyJobs]: BrowseSpecialtyJobsCTA,
  [HygraphSpecialtyCtaType.SearchSpecialtyJobsByLocation]:
    SearchSpecialtyJobsByLocationCTA,
};

export default function SpecialtyCtaRenderer(
  hygraphProps: HygraphSpecialtyCtaProps
) {
  const Component = componentByEnumeration[hygraphProps.specialtyCtaType];
  return <Component {...hygraphProps} />;
}
